<template>
  <div
    class="kk-panel__sub"
    :class="{
      'kk-panel__sub-hidden': !isSubNavigationVisible,
    }"
  >
    <teams v-if="activeSubNavigation === SubNavigations.Teams" />
    <players v-else-if="activeSubNavigation === SubNavigations.Players" />
    <grid-options v-else-if="activeSubNavigation === SubNavigations.Options" />
    <styles-menu v-else-if="activeSubNavigation === SubNavigations.Styles"></styles-menu>
    <settings-menu v-else-if="activeSubNavigation === SubNavigations.Settings"></settings-menu>
    <grids v-else-if="activeSubNavigation === SubNavigations.Grids"></grids>
    <business-case v-else-if="activeSubNavigation === SubNavigations.Businesses"></business-case>
    <processes v-else />
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import Players from "./players/Players.vue";
import Processes from "./processes/Processes.vue";
import GridOptions from "./sheets/GridOptions.vue";
import Grids from "./grid/Grids.vue";
import BusinessCase from "./business/BusinessCase.vue";
import Teams from "./teams/Teams.vue";
import SettingsMenu from "../../settings/SettingsMenu.vue";
import StylesMenu from "./styles/StylesMenu.vue";
import { SubNavigations } from "../../../utils/constants";
SubNavigations;
export default {
  components: {
    Players,
    Processes,
    Teams,
    SettingsMenu,
    StylesMenu,
    GridOptions,
    Grids,
    BusinessCase,
  },
  data() {
    return {
      SubNavigations: SubNavigations,
    };
  },
  computed: {
    isSubNavigationVisible() {
      return this.$store.state.panel.isSubNavigationVisible;
    },

    mainNavigationCollapsed() {
      return !this.$store.state.panel.expanded;
    },
    activeSubNavigation() {
      return this.$store.state.preferences.allPreferences?.activeSubNavigation;
    },
  },
  mounted() {
    hotkeys("ctrl+b,cmd+b", () => {
      this.$store.dispatch("panel/toggleSubNavigationVisibility");
    });
  },
  beforeUnmount() {
    hotkeys.unbind("ctrl+b,cmd+b");
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.kk-panel {
  &__sub {
    flex-grow: 1;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #fff;
    height: calc(100vh - 6rem);
    visibility: visible;
    opacity: 1;
    transition: visibility 0s, opacity 1s linear;

    &-hidden {
      visibility: hidden;
      opacity: 0;
    }
  }
}
</style>
